import { conditionFormChecker, putField } from "../../../utils/form";
import lodash from "lodash";
//import { createFieldAttachment } from "../../../components/input/template-builder/template-builder.logic";
import i18n from "../../../i18n";
import { defineAsyncComponent } from "vue";
import { Form } from "ant-design-vue";

export const AttachIdentityIdCard = defineAsyncComponent(() => import("./attach-identity/AttachIdentityIdCard"));
export const AttachIdentitySignature = defineAsyncComponent(() => import("./attach-identity/AttachIdentitySignature"));
const CardBorder = defineAsyncComponent(() => import("../../../components/card/CardBorder"));
const Attachment = defineAsyncComponent({ loader: () => import("../../../components/input/template-builder/attachment/Attachment") });

export const createField = ({ props, data, key }) => {
    const { viewOnly, menuContext } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            {
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}attachmentDocs.0`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                formItemRender: ({ field }) => {
                    const label = field?.label?.();
                    const formItemProp = field?.formItemProp?.({ field });
                    return (
                        <CardBorder
                            bodyStyle={{ padding: "10px 24px" }}
                            class="mt-3"
                            headerSize="small"
                            title={i18n.global.t("model.user.refAttachDoc")}
                            class="border-radius-1"
                        >
                            <Form.Item label={label} {...formItemProp}>
                                <Attachment
                                    value={model.attachmentDocs?.[0]?.url || model.attachmentDocs?.[0]?.blob ? model.attachmentDocs?.[0] : null}
                                    onUpdate:value={(value) => {
                                        if (!model.attachmentDocs?.[0]) {
                                            model.attachmentDocs.push({});
                                        }
                                        const refAttach = model.attachmentDocs?.[0];
                                        refAttach.name = value?.name;
                                        refAttach.documentName = refAttach.documentName ? refAttach.documentName : value?.name;
                                        refAttach.blob = value?.blob;
                                        refAttach.isSave = value?.isSave;
                                        refAttach.size = value?.size;
                                        refAttach.type = value?.type;
                                        refAttach.group = value?.group;
                                    }}
                                    group={"Doc"}
                                    disabled={viewOnly}
                                ></Attachment>
                            </Form.Item>
                        </CardBorder>
                    );
                },
            },
            // createFieldAttachment({
            //     visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
            //     key: `${prefix}attachmentDocs.0`,
            //     colProp: () => ({ xs: 24 }),
            //     formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            //     label: () => i18n.global.t("model.user.refAttachDoc"),
            //     inputProp: ({ field }) => {
            //         return lodash.merge(
            //             {
            //                 value: model.attachmentDocs?.[0]?.url || model.attachmentDocs?.[0]?.blob ? model.attachmentDocs?.[0] : null,
            //                 "onUpdate:value": (value) => {
            //                     const refAttach = model.attachmentDocs?.[0];
            //                     refAttach.name = value?.name;
            //                     refAttach.documentName = refAttach.documentName ? refAttach.documentName : value?.name;
            //                     refAttach.blob = value?.blob;
            //                     refAttach.isSave = value?.isSave;
            //                     refAttach.size = value?.size;
            //                     refAttach.type = value?.type;
            //                     refAttach.group = value?.group;
            //                 },
            //                 group: "Doc",
            //                 disabled: viewOnly,
            //             },
            //             conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
            //         );
            //     },
            // }),
            {
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}cardIdCard`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            itemsKey: `${prefix}attachmentIdCards`,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "AttachmentIdCard" } })
                    );
                    return (
                        <CardBorder
                            bodyStyle={{ padding: "10px 24px" }}
                            class="mt-3"
                            headerSize="small"
                            title={i18n.global.t("model.user.refAttachIdCard")}
                            class="border-radius-1"
                        >
                            <AttachIdentityIdCard {...componentProp}></AttachIdentityIdCard>
                        </CardBorder>
                    );
                },
            },
            {
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}cardSignature`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            itemsKey: `${prefix}attachmentSignatures`,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "AttachmentSignature" } })
                    );
                    return (
                        <CardBorder
                            bodyStyle={{ padding: "10px 24px" }}
                            class="mt-3"
                            headerSize="small"
                            title={i18n.global.t("model.user.refAttachSignature")}
                            class="border-radius-1"
                        >
                            <AttachIdentitySignature {...componentProp}></AttachIdentitySignature>
                        </CardBorder>
                    );
                },
            },
        ],
    });
};
